// extracted by mini-css-extract-plugin
export default {"cardItem":"CardItem_cardItem__WBSkl"};